import React, { Component, Fragment } from 'react';
import { ModalPopup } from './ModalPopup';

export class LoadingPanel extends Component {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <Fragment>

                <ModalPopup
                    title={'Upload is in progress ..'}
                    text='This may take some time depending on the size of the image you have selected, so please be patient'
                />
            </Fragment>
        );
    }
}